import React from 'react';
import { connect } from 'react-redux';
import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend
} from 'recharts';

import { listWorkBetweenStamps } from '~/actions/boxStats';
import { list } from '~/actions/actions';
import { listUsers } from '~/actions/user';
import sec2str from '~/utils/sec2str';
import { groupBy } from '~/utils/listHelpers';
import {
  isEqual as isEqualDate,
  getDateRange,
  toFromDate,
  toToDate
} from '~/utils/dateHelpers';

import Styles from './widget.scss';

// const chartColors = [
//   '#0095ff',
//   '#0086e6',
//   '#1aa0ff',
//   '#0077cc',
//   '#33aaff',
//   '#0068b3'
// ];
const chartColors = [
  '#0095ff',
  '#00C49F',
  '#FFBB28',
  '#FF8042',
  '#8042ff',
  '#ffdf42',
  '#42c1ff',
  '#ff4262'
];

class BoxTimingChart extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    const dateRange = getDateRange(
      props.indata.from,
      props.indata.to,
      props.indata.period
    );

    this.state = {
      from: dateRange.from,
      to: dateRange.to,
      previousFrom: dateRange.from,
      previousTo: dateRange.to,
      perUsers: null,
      users: [],
      loading: false
    };
  }

  componentDidMount() {
    list(this.props.dispatch, this.context.apiClient);
    this.loadStats();
  }

  componentWillReceiveProps(nextProps) {
    const dateRange = getDateRange(
      nextProps.indata.from,
      nextProps.indata.to,
      nextProps.indata.period
    );
    if (
      !isEqualDate(toFromDate(this.state.previousFrom), dateRange.from) ||
      !isEqualDate(toToDate(this.state.previousTo), dateRange.to)
    ) {
      this.setState(
        {
          from: dateRange.from,
          to: dateRange.to,
          previousFrom: dateRange.from,
          previousTo: dateRange.to
        },
        this.loadStats
      );
    }
  }

  getAverage(userId) {
    const { perUsers, users } = this.state;
    const works = perUsers[userId];
    const user = users.find(u => u.userId === userId);
    const total = {};

    if (works) {
      works.forEach(work => {
        if (total[work.actionId] === undefined) {
          total[work.actionId] = { time: 0, count: 0, average: 0 };
        }
        total[work.actionId].time +=
          (new Date(work.finish).getTime() - new Date(work.created).getTime()) /
          1000;
        total[work.actionId].count += 1;

        if (work.pauses) {
          work.pauses.forEach(pause => {
            if (pause.from && pause.to) {
              total[work.actionId].time +=
                (new Date(pause.to).getTime() -
                  new Date(pause.from).getTime()) /
                1000;
            }
          });
        }
      });
      Object.keys(total).forEach(actionId => {
        total[actionId].average = Math.round(
          total[actionId].time / total[actionId].count
        );
      });
    }

    return { ...user, timings: total };
  }

  getAveragePerUser() {
    const perUsersIds = Object.keys(this.state.perUsers || {});
    return perUsersIds.map(userId => this.getAverage(userId));
  }

  loadStats() {
    const { from, to } = this.state;
    this.setState({ loading: true });
    listWorkBetweenStamps(
      this.props.dispatch,
      this.context.apiClient,
      toFromDate(from, true),
      toToDate(to, true)
    ).then(res => {
      this.setState({ perUsers: groupBy(res.data, 'userId'), loading: false });
    });
    listUsers(this.props.dispatch, this.context.apiClient).then(res => {
      this.setState({ users: res.data, loading: false });
    });
  }

  tooltipFormat(value, barName, barProps) {
    const timeFormatted = sec2str(value);
    const dataKey = barProps.dataKey.split('.')[0];
    const data = barProps.payload[dataKey];

    if (data && data.count) {
      return `${timeFormatted} on ${data.count} box${
        data.count !== 1 ? 'es' : ''
      }`;
    }
    return timeFormatted;
  }

  render() {
    if (this.state.loading) {
      return <div>Loading timings...</div>;
    }
    const users = this.getAveragePerUser();
    return (
      <div className={`${this.props.className} ${Styles.widget}`}>
        <h5 className={Styles.title}>{this.props.indata.title}</h5>
        <div className={Styles.content}>
          {users.length > 0 && (
            <ResponsiveContainer minHeight={400}>
              <BarChart data={users}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis
                  label={{
                    value: 'Minutes',
                    angle: -90,
                    position: 'insideLeft'
                  }}
                  tickFormatter={sec2str}
                />
                <Tooltip formatter={this.tooltipFormat} />
                <Legend />
                {this.props.actions
                  .valueSeq()
                  .map((action, index) => (
                    <Bar
                      key={`bar_${action.get('id')}`}
                      dataKey={`timings.${action.get('id')}.average`}
                      fill={chartColors[index % chartColors.length]}
                      name={action.get('name')}
                    />
                  ))}
                {/* <Bar
                  dataKey="pick.average"
                  fill="#0095ff"
                  name="Picking average"
                />
                <Bar dataKey="qa.average" fill="#465f8a" name="QA average" />
                <Bar
                  dataKey="shipped.average"
                  fill="#364256"
                  name="Shipped average"
                /> */}
              </BarChart>
            </ResponsiveContainer>
          )}
          {users.length === 0 && <div>No data to show.</div>}
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  actions: state.getIn(['actions', 'items'])
});

// Setting pure: false is required for react router to work
export default connect(
  mapStateToProps,
  null,
  null,
  { pure: false }
)(BoxTimingChart);



// WEBPACK FOOTER //
// ./app/widgets.new/BoxTimingChart/widget.js